import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  role: "list",
  class: "mt-auto space-y-1"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "text-xs/6 font-semibold text-gray-400"
}
const _hoisted_4 = {
  role: "list",
  class: "-mx-2 mt-2 space-y-1"
}
const _hoisted_5 = {
  key: 0,
  class: "flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-[0.625rem] font-medium text-gray-400"
}
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = {
  key: 2,
  class: "ml-auto w-9 min-w-max rounded-full px-2.5 py-0.5 text-center text-xs/5 font-medium whitespace-nowrap bg-white ring-gray-200 text-gray-600 ring-1 ring-inset"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "mt-1 pl-8 space-y-1",
  id: "sub-menu-1"
}

import { useRoute } from 'vue-router'
import type { Route } from '@/interfaces'
import { useCollapseState } from '@/composables'
import { SlideTransition } from '@component/Transitions'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'


export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  props: {
    routes: {},
    title: {},
    isBottom: { type: Boolean },
    isGrouped: { type: Boolean }
  },
  setup(__props: any) {

const route = useRoute();
const { isCollapsed, toggle } = useCollapseState("sidebar-collapse-map");



function isActive(prefix: string): string {
  const isActive = route.name?.toString().includes(prefix);

  return isActive ? "bg-gray-100 text-indigo-600" : "text-gray-700 hover:text-indigo-600 hover:bg-gray-100";
}

function isActiveIcon(prefix: string): string {
  const isActive = route.name?.toString().includes(prefix);

  return isActive ? "text-indigo-600 border-indigo-600" : "text-gray-700 group-hover:border-indigo-600 group-hover:text-indigo-600";
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.isBottom)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createVNode(_component_RouterLink, {
              to: { name: route.route },
              target: route.external ? '_blank' : 'target',
              class: _normalizeClass([isActive(route.prefix), 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(route.icon), {
                  class: _normalizeClass([isActiveIcon(route.prefix), 'size-6 shrink-0'])
                }, null, 8, ["class"])),
                _createTextVNode(" " + _toDisplayString(route.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "target", "class"])
          ]))
        }), 256))
      ]))
    : (_openBlock(), _createElementBlock("li", _hoisted_2, [
        (_ctx.isGrouped)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_4, [
          (_ctx.isGrouped)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.routes, (route) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createVNode(_component_RouterLink, {
                    to: { name: route.route },
                    class: _normalizeClass([isActive(route.prefix), 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                  }, {
                    default: _withCtx(() => [
                      ((typeof route.icon === 'string'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(route.icon), 1))
                        : (_openBlock(), _createBlock(_resolveDynamicComponent(route.icon), {
                            key: 1,
                            class: _normalizeClass([isActiveIcon(route.prefix), 'size-6 shrink-0'])
                          }, null, 8, ["class"])),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(route.name), 1),
                      (route.open)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(route.open), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])
                ]))
              }), 256))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.routes, (route) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  (!route.children)
                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                        key: 0,
                        to: { name: route.route },
                        class: _normalizeClass([isActive(route.prefix), 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(route.icon), {
                            class: _normalizeClass([isActiveIcon(route.prefix), 'size-6 shrink-0'])
                          }, null, 8, ["class"])),
                          _createTextVNode(" " + _toDisplayString(route.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_unref(toggle)(route.prefix)),
                          type: "button",
                          class: _normalizeClass([isActive(route.prefix), 'flex hover:cursor-pointer w-full items-center gap-x-3 rounded-md p-2 text-left text-sm/6 font-semibold text-gray-700'])
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(route.icon), { class: "size-6 shrink-0" })),
                          _createTextVNode(" " + _toDisplayString(route.name) + " ", 1),
                          _createVNode(_unref(ChevronRightIcon), {
                            class: _normalizeClass(["ml-auto text-gray-400 size-5 shrink-0 ease-in transition-transform", { 'rotate-90': _unref(isCollapsed)(route.prefix) }])
                          }, null, 8, ["class"])
                        ], 10, _hoisted_9),
                        _createVNode(_unref(SlideTransition), { "is-vertical": "" }, {
                          default: _withCtx(() => [
                            (_unref(isCollapsed)(route.prefix))
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (childRoute) => {
                                    return (_openBlock(), _createBlock(_component_RouterLink, {
                                      is: "li",
                                      to: { name: childRoute.route },
                                      class: _normalizeClass([isActive(childRoute.prefix), 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(childRoute.icon), {
                                          class: _normalizeClass([isActiveIcon(childRoute.prefix), 'size-6 shrink-0'])
                                        }, null, 8, ["class"])),
                                        _createTextVNode(" " + _toDisplayString(childRoute.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "class"]))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                ]))
              }), 256))
        ])
      ]))
}
}

})